// 使用 window.message 代替 antd 静态方法，避免 context 警告

// 复制链接
export const handleCopy = async (url, customMessage) => {
  try {
    // 优先使用 navigator.clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(url || window.location.href);
      (customMessage || window.message)?.success('已复制');
      return;
    }
    
    // 降级方案：使用 document.execCommand
    const textArea = document.createElement('textarea');
    textArea.value = url || window.location.href;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    const successful = document.execCommand('copy');
    document.body.removeChild(textArea);
    
    if (successful) {
      (customMessage || window.message)?.success('已复制');
    } else {
      throw new Error('复制失败');
    }
  } catch (error) {
    console.error('复制失败:', error);
    (customMessage || window.message)?.error('复制失败，请手动复制');
  }
};